import { EventActionType } from './event-action-type';

export interface SetEventOccurrenceDuration {
  type: EventActionType.SetOccurrenceDuration;
  eventKey: string;
  occurrenceIndex: number;
  duration: number;
}

export const setEventOccurrenceDuration = (
  eventKey: string,
  occurrenceIndex: number,
  duration: number,
): SetEventOccurrenceDuration => ({
  eventKey,
  occurrenceIndex,
  duration,
  type: EventActionType.SetOccurrenceDuration,
});
